export const flexProjectContactRole = {
  Customer: 1,
  BillTo: 2,
  ShipTo: 3,
  SoldTo: 4,
}
